import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Th, Td, Empty, fmtDate } from "./ui";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Auditlog" subtitle="Alle gevoelige acties in het portaal" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Actie</Th><Th>Entiteit</Th><Th>Entiteit-ID</Th><Th>IP</Th><Th>Datum</Th></tr></thead>
            <tbody>
              {rows.map((a) => (
                <tr key={a.id} className="border-b border-white/5">
                  <Td className="text-sfc-orange">{a.action}</Td>
                  <Td>{a.entity_type}</Td>
                  <Td className="font-mono text-xs text-white/50">{a.entity_id?.slice(0, 8)}</Td>
                  <Td className="text-white/50">{a.ip_address || "-"}</Td>
                  <Td className="text-white/50">{fmtDate(a.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Geen logs" />}
        </div>
      </Card>
    </div>
  );
}
